import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../common/interfaces/app-config.interface';
import { tap } from 'rxjs/operators';
import { BaseService } from '../../common/services/base.service';

export enum OpCo {
    'DE01' = 'de01',
    'BE01' = 'be01',
    'NL01' = 'nl01',
    'HU01' = 'hu01'
}

@Injectable({providedIn: 'root'})
export class AppConfigService extends BaseService {
    private appConfig: AppConfig;

    constructor(private http: HttpClient) {
        super();
    }

    getAppConfig(): AppConfig {
        return this.appConfig;
    }

    getBEAppConfig() {
        return this.http.get(this.getApiUrl() + '/public/operating-company')
            .pipe(tap((res) => console.log(res)));
    }

    load() {
        const opCo = this.getOpCo();
        const file = `assets/config/config-` + opCo + `.json`;
        const promise = this.http.get(file)
            .toPromise()
            .then((config: AppConfig) => {
                this.appConfig = config;
                return config;
            })
            .catch(() => {
                console.log('Could not load file ' + file);
            });

        return promise;
    }

    private getOpCo(): OpCo {
        const deUrls = [
            'mymateco.local',
            'pilot.qa-mymateco.mysite.qone.mateco.eu',
            'qa-mymateco.mysite.qone.mateco.eu',
            'pp-mymateco.mysite.qone.mateco.eu',
            'pilot.mymateco.de',
            'mymateco.de',
            'www.mymateco.de'];
        const beUrls = [
            'mytvhequipment.local',
            'pilot.qa-mytvhequipment.mysite.qone.mateco.eu',
            'qa-mytvhequipment.mysite.qone.mateco.eu',
            'pp-mytvhequipment.mysite.qone.mateco.eu',
            'pilot.mytvhequipment.com',
            'mytvhequipment.com',
            'www.mytvhequipment.com'];
        const nlUrls = [
            'mymateconl.local',
            'pilot.qa-mymateconl.mysite.qone.mateco.eu',
            'qa-mymateconl.mysite.qone.mateco.eu',
            'pp-mymateconl.mysite.qone.mateco.eu',
            'pilot.mymateco.nl',
            'mymateco.nl',
            'www.mymateco.nl'];
        const huUrls = [
            'mymatecohu.local',
            'qa-mymatecohu.mysite.qone.mateco.eu',
            'pp-mymatecohu.mysite.qone.mateco.eu',
            'mymateco.hu',
            'www.mymateco.hu'];
        const currentUrl = window.location.hostname;

        switch (true) {
            case this.findInList(deUrls, currentUrl):
                return OpCo.DE01;
            case this.findInList(beUrls, currentUrl):
                return OpCo.BE01;
            case this.findInList(nlUrls, currentUrl):
                return OpCo.NL01;
            case this.findInList(huUrls, currentUrl):
                return OpCo.HU01;
            default:
                return OpCo.DE01;
        }
    }

    private findInList(list: string[], value: string) {
        return list.includes(value);
    }
}
